import SideTool from "@/global/components/side-tool";

export default function ComputingMethod() {
    return (
        <div>
            <SideTool />
            ComputingMethod
        </div>
    )
}